import { parse, Allow } from 'partial-json';

// Streaming helpers for LLM tool-call arguments. The args stream token-by-token,
// so mid-run the raw string is a truncated JSON object. Platform-agnostic — no
// rendering, no tool-specific shape assumptions.

/** Parse a (possibly partial) tool-call args string into an object. */
export function parseToolArgs(rawArguments: string | null | undefined): Record<string, unknown> {
  try {
    const parsed: unknown = parse(rawArguments || '', Allow.ALL);
    return isPlainObject(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
